export default __webpack_public_path__ + "static/cTNLspIP-97120abe464764049404f844235a0b30.svg";